export const GET_PUBLIC_DAY_OFFS_REQUEST = "GET_PUBLIC_DAY_OFFS_REQUEST"
export const GET_PUBLIC_DAY_OFFS_SUCCESS = "GET_PUBLIC_DAY_OFFS_SUCCESS"
export const GET_PUBLIC_DAY_OFFS_FAILURE = "GET_PUBLIC_DAY_OFFS_FAILURE"
export const GET_PUBLIC_DAY_OFFS_UNIQUE_YEARS_REQUEST = "GET_PUBLIC_DAY_OFFS_UNIQUE_YEARS_REQUEST"
export const GET_PUBLIC_DAY_OFFS_UNIQUE_YEARS_SUCCESS = "GET_PUBLIC_DAY_OFFS_UNIQUE_YEARS_SUCCESS"
export const GET_PUBLIC_DAY_OFFS_UNIQUE_YEARS_FAILURE = "GET_PUBLIC_DAY_OFFS_UNIQUE_YEARS_FAILURE"
